import { combineReducers } from 'redux'

import loginReducer from './routes/login/reducers/loginReducer'
import chartsReducer from './routes/charts/reducers/chartsReducer'
import chartFormReducer from './routes/charts/reducers/chartFormReducer'
import patientDemographicsFormReducer from './routes/charts/reducers/patientDemographicsFormReducer'
import hospitalAdmissionFormReducer from './routes/charts/reducers/hospitalAdmissionFormReducer'
import infectionCourseFormReducer from './routes/charts/reducers/infectionCourseFormReducer'
import antibioticsUseFormReducer from './routes/charts/reducers/antibioticsUseFormReducer'
import hospitalizationOutcomeFormReducer from './routes/charts/reducers/hospitalizationOutcomeFormReducer'
import chartNotesReducer from './routes/charts/reducers/chartNotesReducer'
import notificationsReducer from './routes/notifications/reducers/notificationsReducer'
import chartStatisticsReducer from './routes/statistics/reducers/chartStatisticsReducer'
import adverseEventsReducer from './routes/adverse-events/reducers/adverseEventsReducer'

const rootReducer = combineReducers({
  loginReducer,
  chartsReducer,
  chartFormReducer,
  patientDemographicsFormReducer,
  hospitalAdmissionFormReducer,
  infectionCourseFormReducer,
  antibioticsUseFormReducer,
  hospitalizationOutcomeFormReducer,
  chartNotesReducer,
  notificationsReducer,
  chartStatisticsReducer,
  adverseEventsReducer,
})

export default rootReducer
